import axiosClient from "./axiosClient";

export const listarPaises = () => axiosClient.get("/paises").then((r) => r.data);
